import { Button } from '@graftcode/design-system'

import { ACADEMY_MENU_ROUTES } from '../../const/academyMenuRoutes.const'
import type { TutorialSection } from '../../types'

import styles from '../../../../MobileMenu.module.scss'

type QuickStartListProps = {
  sections: TutorialSection[]
  currentTutorialPath?: string
  onSectionClick: (section: TutorialSection, basePath: string) => void
}

export function QuickStartList({ sections, currentTutorialPath, onSectionClick }: QuickStartListProps) {
  return (
    <div className={styles.academyQuickStartList}>
      {sections
        .sort((a, b) => a.order - b.order)
        .map((section) => {
          const isActive = currentTutorialPath === section.path

          return (
            <Button
              key={section.path}
              variant="ghost"
              size="l"
              fullWidth
              text={section.title}
              onClick={() => onSectionClick(section, ACADEMY_MENU_ROUTES.quickStart)}
              className={`${styles.academyArticle} ${isActive ? styles.active : ''}`}
              style={{ justifyContent: 'flex-start' }}
            />
          )
        })}
    </div>
  )
}
